var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"mx-2",attrs:{"size":22,"width":3,"indeterminate":""}})}
var staticRenderFns = []

export { render, staticRenderFns }